import { Outlet } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions.js';
import AccessDenied from './AccessDenied.jsx';
import PermissionLoadingSkeleton from './PermissionLoadingSkeleton.jsx';

const isAllowed = ({ codename, any, all, hasPermission, hasAny, hasAll }) => {
  if (codename && !hasPermission(codename)) {
    return false;
  }

  if (any && !hasAny(any)) {
    return false;
  }

  if (all && !hasAll(all)) {
    return false;
  }

  return true;
};

export default function RequirePermission({
  codename,
  any,
  all,
  children,
  fallback,
  loadingFallback,
}) {
  const { loading, hasPermission, hasAny, hasAll } = usePermissions();

  if (loading) {
    return loadingFallback ?? <PermissionLoadingSkeleton />;
  }

  if (!isAllowed({ codename, any, all, hasPermission, hasAny, hasAll })) {
    return fallback ?? <AccessDenied />;
  }

  return children ?? <Outlet />;
}
